<template>
 <div>
  <b-row>
    <b-col md="1">
    </b-col>
    <b-col md="10">
      <b-card md="1" bg-variant="none"> {{description}}</b-card>
    </b-col>
    <b-col md="1">
    </b-col>
  </b-row>
  <br>
  <b-row>
    <b-col md="1">
    </b-col>
    <b-col md="10">
  <b-card bg-variant="light">
    <div v-if="showBrandSelection">
      <brand-select @selectedItems="setBrandId" heading="Product Model Brand Selection" />
    </div>
    <div v-if="showInterestSelection">
      <interest-select
        @selectedItems="setInterestId"
        :filtering="filtering"
        select_table_heading="Product Model Interest Selection"
      />
    </div>
    <b-form-group 
      label-cols-lg="3"
      label="Product Model"
      label-size="lg"
      label-class="font-weight-bold pt-0"
      class="mb-0"
    >
      <b-form-group
        label="Model Name:"
        label-for="nested-name"
        label-cols-sm="3"
        label-align-sm="right"
      >
        <b-form-input id="nested-name"
          v-model="attr_copy.name"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="Description:"
        label-for="nested-description"
        label-cols-sm="3"
        label-align-sm="right"
      >
        <b-form-input id="nested-description"
          v-model="attr_copy.description"
        ></b-form-input>
      </b-form-group>
    </b-form-group>
    <br>
  </b-card>
  </b-col>
  <b-col md="1">
    <data-operations
      :modified="modified"
      :can_update="canUpdate"
      :can_delete="canDelete"
      :can_help="canHelp"
      @update="doUpdate"
      @undo="doUndo"
      @delete="doDelete"
      @cancel="doCancel"
      @help="doHelp"
    ></data-operations>
  </b-col>
  </b-row>
 </div>
</template>

<script>
import {http_v1} from '@/axios'
import BrandSelect from './BrandSelect.vue'
import InterestSelect from './InterestSelect.vue'
import {amsMofifiedAttrs} from '@/utils'
import {deepEqual} from '@/utils'
import {amsSchema} from '@/schema'
import DataOperations from './DataOperations.vue'

export default {
  components: {
    BrandSelect,
    InterestSelect,
    DataOperations
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  },
  data () {
    return {
      ams_type: 'product-models',
      ams_api_path: 'api/admin/v1/',
      modified: false,
      attr_copy: {},
      attr_orig: {},
      description: undefined,
      filtering: {
        ids: this.$store.getters['cached_products/interest_ids']
      },
    }
  },
  computed: {
    showBrandSelection() {
      return !(this.attr_copy['brand-id']?.length)
    },
    showInterestSelection() {
      return !(this.attr_copy['interest-id']?.length)
    },
    canUpdate() {
      return (this.attr_copy['brand-id']?.length > 0 && this.attr_copy['name']?.length > 0)
    },
    canDelete() {
      return false
    },
    canHelp() {
      return true
    }
  },
  methods: {
    doUpdate() {
      this.callApi()
    },
    doUndo() {
        this.attr_copy = Object.assign( {}, this.attr_orig)
    },
    doCancel() {
      this.$emit('noAction')
      if(this.reroute) {
        this.$router.go(-1)
      }
    },
    doDelete() {
    },
    doHelp() {
      http_v1.get(this.ams_api_path + 'features', {
        params: {
          title: this.ams_type
        }
      }).then(response => {
        if( response.data) {
          let feature = response.data.data[0]
          this.$router.push( {path: '/features' + '/' + feature.id + '/show'} )
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    setBrandId(items) {
      this.attr_copy['brand-id'] = items[0].id
      this.description = this.description +  " " + items[0].attributes['name']
    },
    setInterestId(items) {
      this.attr_copy['interest-id'] = items[0].id
      this.description = this.description +  " " + items[0].attributes['name']
    },
    apiResourcePath() {
      return this.ams_api_path + this.ams_type.replace(/-/g, '_')
    },
    callApi () {
      let attr_params = amsMofifiedAttrs(this.attr_copy, this.attr_orig)
      http_v1.post (
        this.apiResourcePath(), {
          ...attr_params
        }
      ).then(response => {
        if( response.data) {
          this.$store.dispatch(
            'cached_products/add_product',
            response.data.data
          ).then(() => {
          }).catch(() => {
          })
          this.$emit('takeAction')
        }
        if(this.reroute) {
          this.$router.go(-1)
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    // callCancel() {
    //   this.$emit('noAction')
    //   if(this.reroute) {
    //     this.$router.go(-1)
    //   }
    // }
  },
  watch: {
     attr_copy : {
        handler() {
          if(deepEqual(this.attr_copy,this.attr_orig)) {
            this.modified = false
          }
          else {
            this.modified = true
          }
        },
        deep: true
     },
  },
  mounted() {
    if(this.ams_template?.attributes) {
      this.attr_copy = Object.assign( {}, {...this.ams_template.attributes})
    }
    else {
      const included_obj = amsSchema.find( 
        el =>  
        el.type === this.ams_type
      )
      this.attr_copy = Object.assign({}, {...included_obj.attributes})
    }
    this.description = this.ams_template?.description || ''
  }
}
</script>